/*
  Ajándék címzett szerint section - mobil lapozónyilak és állapotkezelés.
  Készítette: Varga Bálint | branch: dev/balint | 2026-08-27
*/

(() => {
  const initializeSlider = (section) => {
    if (section.dataset.bmGiftSliderReady === "true") return;

    const track = section.querySelector(".bm-gift-recipients__track--swipe-mobile");
    const previousButton = section.querySelector("[data-bm-gift-previous]");
    const nextButton = section.querySelector("[data-bm-gift-next]");

    if (!track || !previousButton || !nextButton) return;

    const getStep = () => {
      const firstCard = track.querySelector(".bm-gift-recipient");
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap) || 0;
      return (firstCard?.getBoundingClientRect().width || track.clientWidth) + gap;
    };

    const updateButtons = () => {
      const remainingScroll = track.scrollWidth - track.clientWidth;
      previousButton.disabled = track.scrollLeft <= 2;
      nextButton.disabled = track.scrollLeft >= remainingScroll - 2;
    };

    previousButton.addEventListener("click", () => {
      track.scrollBy({ left: -getStep(), behavior: "smooth" });
    });

    nextButton.addEventListener("click", () => {
      track.scrollBy({ left: getStep(), behavior: "smooth" });
    });

    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    updateButtons();
    section.dataset.bmGiftSliderReady = "true";
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(".bm-gift-recipients").forEach(initializeSlider);
  };

  document.addEventListener("DOMContentLoaded", () => initializeAll());
  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
